import { TYPE_COLLECTION } from '../input-types';

export const id = 'deliveryStatusAsCollection';
export const apiKey = 'deliveryStatus';
export const type = TYPE_COLLECTION;

export const deliveryStatusAsCollection = {
  id,
  apiKey,
  type,
};
